const pickChangedFields = require('./pickChangedFields')

module.exports = (angularModule) => {
  angularModule.directive('whiteLabelConfigEditor', () => {
    return {
      restrict: 'E',
      template: require('./whiteLabelConfigEditor.html'),
      scope: {
        model: '=',
        accountId: '='
      },
      controller: ($scope, $uibModal) => {

        function openImageLogoModal() {
          openImageUploadModal("Logo", { parent: $scope.model, key: "logoUrl" })
            .then(() => {
              // disable default darkThemeLogoUrl if they change primary logo
              // TODO support configurable #DarkThemeLogo
              $scope.model.darkThemeLogoUrl = "";
            })
        }
        function openImageUploadModal(imageType, source) {

          let modalInstance = $uibModal.open({
            template: require('../../../../common/imageUpload/imageUploadModal.html'),
            size: 'md',
            controller: "ImageUploadModalCtrl",
            windowClass: "image-upload-modal",
            resolve: {
              imageType: () => imageType,
              accountId: () => $scope.accountId,
              preventSave: () => true,
              imageUploadEndpoint: () => "/image/upload",
              afterSaveCallback: () => (uploadedImageUrl) => {
              },
            }
          });

          return modalInstance.result.then((result) => {
            source.parent[source.key] = result
          })

        }
        $scope.openImageLogoModal = openImageLogoModal
        $scope.onImageUploadModal = openImageUploadModal

      }
    }
  })
}


module.exports.fromConfig = (config) => {
  return {
    name: config.brandConfig.name,
    logoUrl: config.brandConfig.logoUrl,
    darkThemeLogoUrl: config.brandConfig.darkThemeLogoUrl,
    hostName: config.brandConfig.hostname,
    faviconUrl: config.brandConfig.faviconUrl,
    logoutRedirectUrl: config.brandConfig.logoutRedirectUrl,
    emailAddress: config.emailConfig.emailAddress,
    emailSenderName: config.emailConfig.emailSenderName,
    subject: config.emailConfig.dailyAlertConfig.subject,
    emailHeaderImage: config.emailConfig.emailHeaderImage,
    dashboardLink: config.emailConfig.dashboardLink,
    disableHtmlEditor: config.emailConfig.emailRestrictions.disableHtmlEditor,
    reviewBuilderProviderName: config.brandConfig.reviewBuilderProviderName,
  }
}

module.exports.toConfig = (whiteLabelConfig) => {
  // TODO currently endpoint treats all fields as additive merges.
  // Can't delete something once set (can only set to empty strings, which isn't really correct)
  return {
    brandConfig: {
      logoUrl: whiteLabelConfig.logoUrl,
      darkThemeLogoUrl: whiteLabelConfig.darkThemeLogoUrl,
      reviewBuilderProviderName: whiteLabelConfig.reviewBuilderProviderName,
      name: whiteLabelConfig.name,
      hostname: whiteLabelConfig.hostName,
      faviconUrl: whiteLabelConfig.faviconUrl,
      logoutRedirectUrl: whiteLabelConfig.logoutRedirectUrl
    },
    emailConfig: {
      emailAddress: whiteLabelConfig.emailAddress,
      emailSenderName: whiteLabelConfig.emailSenderName,
      dailyAlertConfig: {
        subject: whiteLabelConfig.subject
      },
      emailHeaderImage: whiteLabelConfig.emailHeaderImage,
      dashboardLink: whiteLabelConfig.dashboardLink,
      emailRestrictions: {disableHtmlEditor:whiteLabelConfig.disableHtmlEditor}
    }
  }
}

module.exports.sparsify = (before, after) => pickChangedFields(before, after);

